'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NonHostContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _NonHostContainer = require('./NonHostContainer.scss');

var _NonHostContainer2 = _interopRequireDefault(_NonHostContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NonHostContainer(props) {
  var text = props.text;
  var components = props.components;


  return _react2.default.createElement(
    'div',
    { className: _NonHostContainer2.default.nonHostroot },
    _react2.default.createElement(
      'div',
      { className: _NonHostContainer2.default.nonHostheaderText },
      'NON HOST/API CARRIERS'
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'form',
        { className: _NonHostContainer2.default.fullRulesText },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement('input', {
            name: 'isGoing',
            type: 'checkbox'
          }),
          'DISPLAY FULL RULES CONTENT'
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/NonHostContainer/NonHostContainer.jsx
// module id = 1464
// module chunks = 0